/* eslint-disable no-magic-numbers */
import React, { useEffect, useState, useMemo, useRef } from 'react'
import { Button, Toast, Popup } from 'antd-mobile'
import styles from './authorize-commom-page.module.scss'
import Header from '@/components/header/header'
import classNames from 'classnames'
import ProductList from '@/components/product-list/product-list'
import productApi, { ProductListResponse, ProductListParams } from '@/apis/product'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import { isIOS, isAndroid, isInWeChat, isMobile, download, Storage } from '@bihu/common-js'
import activityApi from '@/apis/activity'
import copy from 'copy-to-clipboard'
import { ENTER_AGREEMENT, TOKEN } from '@/constants/storage'
import indexApi from '@/apis'
import halfProcessApi from '@/apis/half-process'
import ProtocolIdsConfirm1 from '../protocolIds-confirm-1/protocolIds-confirm-1'
import ProtocolIdsConfirm2 from '../protocolIds-confirm-2/protocolIds-confirm-2'
import useFirstOrAfter from '@/hooks/use-first-or-after'
import ApiToH5Skin from './components/api-to-h5-skin/api-to-h5-skin'
import { selectUserInfo } from '@/store/user'
import { useAppSelector } from '@/store/hooks'
import { parseUrlJsonParam } from '@/utils/utils'

interface Props{}


const Authorize:React.FC<Props> = () => {
  const ProtocolIdsConfirm1ModalRef: any = useRef()
  const ProtocolIdsConfirm2ModalRef: any = useRef()
  const [search] = useSearchParams()
  const location = useLocation()
  const userInfo = useAppSelector(selectUserInfo)
  /** 上游半流程入口 /half/apply */
  const isHalfProcess = location.pathname.includes('/half/apply')
  const halfProcessSubmittingRef = useRef(false)

  const [details, setDetails] = useState<any>({})
  const [rqResult, setRqResult] = useState<any>()
  const wholeProcessBumpVO = useMemo(
    () => rqResult?.wftWholeProcessBumpVO || rqResult?.yqlWholeProcessBumpVO,
    [rqResult]
  )
  const [otherProtocols, setotherProtocols] = useState([])
  const [youqianlaiProtocol, setYouqianlaiProtocol] = useState<any>('')
  const [agreementContent, setAgreementContent] = useState('')

  const navigate = useNavigate()

  useFirstOrAfter(() => {
    localStorage.removeItem('productBack')

    if (!Storage.get('isRefreshLoadPage') && !search.get('refresh')) {
      Storage.set('isRefreshLoadPage', true)
      // window.location.href = `${document.URL}&refresh=1`
      return
    } else {
      Storage.set('isRefreshLoadPage', false)
    }

    // 监听浏览器回退事件
    window.addEventListener('popstate', back, false)
    // window.onpopstate = back
    window.history.pushState(null, 'null', document.URL)

    return () => {
      // 回退事件只用于当前组件，则需要在组件销毁时把回退事件销毁
      window.removeEventListener('popstate', back, false)
      // window.onpopstate = null
    }
  }, () => {
  // eslint-disable-next-line no-console
    console.log('afterFn')
  }, [])

  // 打开挽留弹窗
  const openProtocolIdsConfirm1Modal = () => {
    let tempYouqianlaiProtocol = ''
    let temPotherProtocols:any = []
    // eslint-disable-next-line array-callback-return
    ;(rqResult?.protocols || []).map((item:any) => {
      if (item.protocolType !== 1) {
        temPotherProtocols.push(item)
      } else if (item.protocolType === 1) {
        tempYouqianlaiProtocol = item
      }
    })
    ProtocolIdsConfirm1ModalRef.current.init({
      quota: details.applyLimit >= 3 ? '100,000' : '50,000',
      productName: rqResult.productName,
      youqianlaiProtocol: tempYouqianlaiProtocol || youqianlaiProtocol || '',
      otherProtocols: temPotherProtocols.length > 0 ? temPotherProtocols : (otherProtocols || []),
      productId: rqResult.id,
      serialNo: protocolSerialNo,
    })
  }

  // 返回
  const back = () => {
    // 半流程不弹挽留，直接返回
    if (isHalfProcess) {
      navigate(-1)
      return
    }
    const isShowPopupStorage = Storage.get('isShowPopup')

    try {
      if (isShowPopupStorage) {
        Storage.set('isShowPopup', false)
        navigate(-1)
      } else {
        //  阻止浏览器回退事件
        openProtocolIdsConfirm1Modal()
        Storage.set('isRefreshLoadPage', false)
        // window.history.pushState(null, 'null', document.URL)
        // localStorage.setItem('productBack', formatTime(Date.now(), 'YYYY-MM-DD'))
        Storage.set('isShowPopup', true)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      // console.log(error)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }

  const [token, setToken] = useState('')
  const [apiChannelCode, setApiChannelCode] = useState('')
  const [serialNo, setSerialNo] = useState('')
  const [isSpecialChannel, setIsSpecialChannel] = useState<boolean>(false)
  const [jumpUrl, setJumpUrl] = useState('')
  // 当前操作第几回授权
  const [authNum, setAuthNum] = useState(0)
  const protocolSerialNo = useMemo(
    () => rqResult?.serialNo || serialNo || details?.serialNo,
    [rqResult, serialNo, details]
  )
  let urlRqResult:any = search.get('rqResult')
  useEffect(() => {
    // 上游半流程：解析 serialNo / token / adChannelCode
    if (isHalfProcess) {
      const urlSerialNo:any = search.get('serialNo')
      const urlToken:any = search.get('token')
      const urlAdChannelCode:any = search.get('adChannelCode')
      if (!urlSerialNo || !urlToken) {
        Toast.show('链接无效，请返回重试')
        window.location.replace('/failure')
        return
      }
      Storage.set(TOKEN, urlToken)
      setToken(urlToken)
      setSerialNo(urlSerialNo)
      if (urlAdChannelCode) {
        localStorage.setItem('ad_channel_code', urlAdChannelCode)
      }
      return
    }

    let urlApiChannelCode:any = search.get('apiChannelCode')
    let urlSerialNo:any = search.get('serialNo')
    let urlToken:any = search.get('token')
    let urlJumpUrl:any = search.get('jumpUrl')
    //设置authNum
    let urlAuthNum:any = search.get('authNum')
    if (urlAuthNum) {
      setAuthNum(Number(urlAuthNum))
    }
    if (urlApiChannelCode) {
      setSerialNo(urlSerialNo)
      setApiChannelCode(urlApiChannelCode)
      localStorage.setItem('ad_channel_code', urlApiChannelCode)
      if (urlJumpUrl) {
        setJumpUrl(parseUrlJsonParam(urlJumpUrl, ''))
      }
      if (urlApiChannelCode === 'kxj01' || urlApiChannelCode === 'kxj02') {
        setIsSpecialChannel(true)
      }
      if (urlToken) {
        Storage.set(TOKEN, urlToken)
        setToken(urlToken)
      }
    } else {
      const pageOptions = search.get('options') || search.get('urlParam')
      const tempDetails = parseUrlJsonParam<any>(pageOptions)
      setDetails(tempDetails)
      setRqResult(tempDetails.rqResult)
    }
  }, [])

  // 半流程：拉产品上下文 + 按普通授权页方式查协议
  useEffect(() => {
    if (!isHalfProcess || !token || !serialNo) {
      return
    }
    async function fetchHalfProcessContext() {
      try {
        const res = await halfProcessApi.getContext(serialNo)
        if (!res || !res.productId) {
          Toast.show('申请已失效，请返回重试')
          window.location.replace('/failure')
          return
        }
        const channelCode = search.get('adChannelCode') || ''
        setDetails({
          adChannelCode: channelCode,
          serialNo: res.serialNo || serialNo,
        })

        // 协议与普通 H5 申请页一致：context 内 getProtocolIds 结果（id/name/protocolType），
        // 正文仍由下方 youqianlaiProtocol → getAgreementInfo 拉取
        setRqResult({
          id: res.productId,
          productName: res.productName,
          productCompany: res.companyName,
          productLogo: res.productLogo,
          serialNo: res.serialNo || serialNo,
          protocols: res.protocols || [],
          thirdpartyType: 8,
          todayMatchNum: 0,
        })
      } catch (error: any) {
        const msg = error?.msg || ''
        if (typeof msg === 'string' && (msg.includes('不匹配') || msg.toLowerCase().includes('uid'))) {
          Toast.show('账号不匹配，请使用原链接进入')
        } else {
          Toast.show(msg || '申请已失效，请返回重试')
        }
        window.location.replace('/failure')
      }
    }
    fetchHalfProcessContext()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHalfProcess, token, serialNo])

  // 应用在API采量授权页重刷的场景
  const reVisitApiAuthPage = () => {
    if (urlRqResult) {
      const tempRqResult = parseUrlJsonParam(urlRqResult)
      setRqResult(tempRqResult)
      setDetails({
        applyLimit: tempRqResult.applyLimit
      })
    }
  }

  useEffect(() => {
    let newProtocols:any = []
    let mainProtocol: any = ''
    // eslint-disable-next-line array-callback-return
    rqResult && rqResult.protocols && rqResult.protocols.map((item:any, index:number) => {
      if (item.protocolType !== 1) {
        newProtocols.push(item)
      } else if (item.protocolType === 1) {
        mainProtocol = item
      }
    })

    // 针对卫付通全流程类型的合作方式，需要把第三方协议并入合作机构协议中展示
    if (rqResult && rqResult.thirdpartyType === 7) {
      const bumpVO = rqResult.wftWholeProcessBumpVO || rqResult.yqlWholeProcessBumpVO
      // 仅当确实有机构协议列表时合并；无机构相关协议时跳过，避免非数组 .map 抛错
      if (Array.isArray(bumpVO?.partnerProtocolList) && bumpVO.partnerProtocolList.length > 0) {
        // 兼容下游字段名差异：name/url、protocolName/protocolUrl、contractName/contractUrl
        const normalizedPartnerProtocols = bumpVO.partnerProtocolList
          .filter(Boolean)
          .map((item:any) => ({
            ...item,
            id: item.id,
            name: item.name || item.protocolName || item.contractName,
            url: item.url || item.protocolUrl || item.protocolValue || item.contractUrl,
          }))
        newProtocols = [
          ...newProtocols,
          ...normalizedPartnerProtocols
        ]
      }
    }
    setYouqianlaiProtocol(mainProtocol || '')
    setotherProtocols(newProtocols)
  }, [rqResult])

  useEffect(() => {
    async function getAgreementInfo() {
      if (!youqianlaiProtocol?.id) {
        return
      }
      try {
        const res:any = await indexApi.getAgreementInfo(youqianlaiProtocol.id, rqResult.id, protocolSerialNo || undefined)
        setAgreementContent(res?.content || '')
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('getAgreementInfo failed', error)
        setAgreementContent('')
      }
    }

    if (youqianlaiProtocol) {
      getAgreementInfo()
    }

  }, [youqianlaiProtocol, protocolSerialNo])

  const toHuiYiHuaPage = (res:any) => {
    if (apiChannelCode) {
      const tempUrl = `/fill-information/authorize?options=${encodeURIComponent(JSON.stringify(res))}&apiChannelCode=${apiChannelCode}&applyLimit=${res.applyLimit}&jumpUrl=${encodeURIComponent(JSON.stringify(jumpUrl))}&serialNo=${serialNo}`
      window.location.replace(tempUrl)
    } else {
      window.location.replace(`/fill-information/authorize?options=${encodeURIComponent(JSON.stringify(res))}&adChannelCode=${details.adChannelCode}&isHuaWeiPhone=${details.isHuaWeiPhone}&applyLimit=${res.applyLimit}`)
    }
  }

  useEffect(() => {
    async function getFomrSubmitStatus() {
      const res:any = await indexApi.getFomrSubmitStatus({
        adChannelCode: apiChannelCode,
        serialNo
      })
      // 如果用户已经授权过，并且第二回授权没有结果，跳转到上回结果页
      if (res.submitStatus === 10 && res.rematchResult !== 3) {
        const reMatchResult:any = res
        let tempOptions:any = {}
        // 否则取上回的结果，跳至下载页
        tempOptions = JSON.parse(JSON.stringify(reMatchResult))
        tempOptions.isNotFormReq = true // 标记为非表单请求方式的跳转
        tempOptions.rePageShowType = 0
        tempOptions.revisit = true // 标记为再访
        window.location.replace(`/fill-information/success?options=${encodeURIComponent(JSON.stringify(tempOptions))}`)

        return
      }
      // 判断是否匹配回调类型(如：惠逸花、惠逸花A)
      if (res.thirdpartyType === 5) {
        toHuiYiHuaPage(res)
        return
      }

      setDetails({
        applyLimit: res.applyLimit
      })
      setRqResult(res)
    }

    // 说明当前路由已被修改，从URl中获取修改后的数据
    if (apiChannelCode && authNum > 0) {
      reVisitApiAuthPage()
    } else if (token && apiChannelCode) {
      getFomrSubmitStatus()
      let devicePlatForm:any = 3
      if (isAndroid) {
        devicePlatForm = 1
      }
      if (isIOS) {
        devicePlatForm = 2
      }
      indexApi.reportPhoneType(devicePlatForm)
    }

  }, [token, apiChannelCode, serialNo])


  // 渠道编码
  const [adChannelCode, setAdChannelCode] = useState('')

  useEffect(() => {
    const code = search.get('adChannelCode')
    if (code) {
      setAdChannelCode(code)
      localStorage.setItem('ad_channel_code', code)
    }
  }, [])

  // 选择协议
  const [checked, setChecked] = useState(false)

  // 切换选中协议
  const checkedTaggle = () => {
    setChecked(!checked)
  }

  // 按钮loading
  const [btnLoading, setBtnLoading] = useState(false)

  // 跳转页面
  const openOtherView = (url: string) => {
    Storage.set(ENTER_AGREEMENT, true)
    window.location.href = url
  }

  const submitApplication = async(isNeedChecked = true) => {
    try {
      // 上游半流程：复用通用产品申请接口真正进件
      if (isHalfProcess) {
        if (!checked && isNeedChecked && youqianlaiProtocol?.id) {
          ProtocolIdsConfirm2ModalRef.current.init({
            youqianlaiProtocol: youqianlaiProtocol || '',
            otherProtocols: otherProtocols || [],
            productId: rqResult.id,
            serialNo: protocolSerialNo,
          })
          return
        }
        if (halfProcessSubmittingRef.current) {
          return
        }
        halfProcessSubmittingRef.current = true
        setBtnLoading(true)
        try {
          const res:any = await productApi.apply({
            productId: rqResult.id,
            serialNo: protocolSerialNo || serialNo,
            appH5: 2,
          })
          if (res?.applyStatus === 1) {
            window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({
              ...res,
              productName: rqResult.productName,
              applyStatus: res.applyStatus,
            }))}`
          } else {
            Toast.show('申请失败，请稍后重试')
          }
        } catch (error: any) {
          Toast.show(error?.msg || '申请失败，请稍后重试')
        } finally {
          halfProcessSubmittingRef.current = false
          setBtnLoading(false)
        }
        return
      }

      if (!checked && isNeedChecked) {
        ProtocolIdsConfirm2ModalRef.current.init({
          youqianlaiProtocol: youqianlaiProtocol || '',
          otherProtocols: otherProtocols || [],
          productId: rqResult.id,
          serialNo: protocolSerialNo,
        })
        return
      }

      const protocols = rqResult?.protocols || []
      let protocolIds = protocols.map((item:any) => item.id).filter(Boolean)

      // 全流程：合作方协议若带 id 一并提交
      if (rqResult.thirdpartyType === 7) {
        const bumpVO = rqResult.wftWholeProcessBumpVO || rqResult.yqlWholeProcessBumpVO
        const partnerIds = (bumpVO?.partnerProtocolList || [])
          .map((item:any) => item.id)
          .filter(Boolean)
        protocolIds = Array.from(new Set([...protocolIds, ...partnerIds]))
      }

      // 如果匹配到的是H5产品，则走H5产品的申请、联登流程
      if (rqResult.thirdpartyType === 1) {
        handleH5Product(rqResult.id, 0, protocolIds)
        return
      }

      //获取在登录页时保存的百度渠道的全链接
      const bdVidUrl = localStorage.getItem('baiduVistLink') || ''
      setBtnLoading(true)
      // 前端日志上报
      const reportParam = `uid:${userInfo?.uid},adChannelCode:${details.adChannelCode || apiChannelCode},event:授权点击`
      indexApi.reportLog(reportParam)
      // 信息授权
      const res:any = await indexApi.confirmAuthorize({
        productId: rqResult.id,
        protocolIds,
        agree: true,
        adChannelCode: details.adChannelCode,
        isHuaWeiPhone: details.isHuaWeiPhone,
        apiChannelCode,
        bdVidUrl,
        orderNum: authNum, //第几回授权
        serialNo: rqResult.serialNo || serialNo
      })
      setBtnLoading(false)
      handleAduitSuccess(res)
    } catch (error: any) {
      setBtnLoading(false)
      Toast.show(error?.msg || '授权失败，请稍后重试')
    }
  }

  // 处理H5产品逻辑
  const handleH5Product = async(productId:any, entranceType:number, protocolIds:any) => {
    // 申请产品
    let applyProductRes:any = await indexApi.applyFor({
      productId,
      entranceType,
      appH5: 2
    })
    // 判断是否需要联登
    // if (applyProductRes.unionLoginFlag === 1) {
    //   try {
    //     const authH5ProductRes:any = await indexApi.authH5Product({
    //       productId,
    //       protocolIds: `${protocolIds}${''}`,
    //       agree: true,
    //       entranceType,
    //       appH5: 2
    //     })
    //     if (authH5ProductRes) {
    //       window.location.href = authH5ProductRes
    //     } else {
    //       window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({ rePageShowType: details.adChannelCode === '9o0w2B' && details.isHuaWeiPhone ? 2 : 0 }))}`
    //     }
    //   } catch (error) {
    //     window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({ rePageShowType: details.adChannelCode === '9o0w2B' && details.isHuaWeiPhone ? 2 : 0 }))}`
    //   }
    // } else {
    //   window.location.href = applyProductRes.thirdpartyTargetUrl
    // }
    window.location.href = applyProductRes.thirdpartyTargetUrl
  }

  // 修改页面url
  const reFreshPageUrl = (newRqResult:any, tempAuthNum: any) => {
    const pageUrl = window.location.origin + window.location.pathname
    let urlOptions = ''
    // 如果是API采量授权方式
    if (apiChannelCode) {
      let modifiedUrl = `${pageUrl}?apiChannelCode=${apiChannelCode}&jumpUrl=${encodeURIComponent(JSON.stringify(jumpUrl))}&authNum=${tempAuthNum}&rqResult=${encodeURIComponent(JSON.stringify(newRqResult))}&serialNo=${serialNo}`
      window.history.replaceState(null, 'null', modifiedUrl)
    } else {
      urlOptions = {
        ...details,
        rqResult: newRqResult,
      }

      window.history.replaceState(null, 'null', `${pageUrl}?options=${encodeURIComponent(JSON.stringify(urlOptions))}&authNum=${tempAuthNum}`)
    }
  }

  const handleAduitSuccess = async(res:any) => {
    // 正常授权且有结果
    if (res && res.applyStatus !== 2) {
      // 如果url上有携带跳转地址jumpUrl，则跳转
      if (jumpUrl) {
        res.jumpUrl = jumpUrl
        window.location.href = `/fill-information/success-transfer?options=${encodeURIComponent(JSON.stringify(res))}`
        return
      }
      // 如果是API转H5类型，则直接跳转第三方链接
      if (res.thirdpartyType === 4 && res.thirdpartyTargetUrl) {
        await indexApi.apiH5JumpUrlSuccessFlag({
          uid: userInfo?.uid,
          productId: rqResult.id,
          productName: rqResult.productName,
          thirdpartyTargetUrl: res.thirdpartyTargetUrl
        })
        window.location.href = res.thirdpartyTargetUrl
        return
      }
      // 卫付通半流程：申请成功返回跳转地址时直接跳转
      if (res.thirdpartyType === 8 && res.thirdpartyTargetUrl) {
        window.location.href = res.thirdpartyTargetUrl
        return
      }

      // 如果授权失败，但是有返回下一个产品，就重新授权
      if (res.applyStatus === 4 && res.productNextMatchDTO) {
        // productNextMatchDTO没有返回serialNo，需要保存
        if (rqResult.serialNo) {
          res.productNextMatchDTO.serialNo = rqResult.serialNo
        }
        // 判断是否匹配回调类型(如：惠逸花、惠逸花A)
        if (res.productNextMatchDTO.thirdpartyType === 5) {
          toHuiYiHuaPage(res.productNextMatchDTO)
          return
        }
        // 如果是其它产品，则更新本页面信息
        setRqResult(res.productNextMatchDTO)
        setAuthNum(res.productNextMatchDTO.orderNum)
        Toast.show('申请名额已满，您的匹配机构已更新，请继续操作')
        reFreshPageUrl(res.productNextMatchDTO, res.productNextMatchDTO.orderNum)
        return
      }

      // 仅透传结果页必要字段，避免全流程大报文导致 URL 过长解析失败白屏
      window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({
        productName: res.productName || rqResult?.productName,
        applyStatus: res.applyStatus,
        rePageShowType: res.rePageShowType,
        revisit: res.revisit,
      }))}`
      return
    }

    // 结果页
    // 走这里说明是重复授权或者授权失败，重复授权也需要判断res
    const options:any = res ? {
      productName: res.productName || rqResult?.productName,
      applyStatus: res.applyStatus,
      rePageShowType: res.rePageShowType,
      revisit: res.revisit,
    } : { rePageShowType: details.adChannelCode === '9o0w2B' && details.isHuaWeiPhone ? 2 : 0 }
    window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify(options))}`
  }
  const handleLoginSuccess = (res:any) => {
    //
  }
  const handelSubmitData = () => {
    setChecked(true)
    submitApplication(false)
  }

  // 弹起协议相关列表
  const openProtocolsPopup = () => {
    setProtocolIdsVisible(true)
  }

  // 是否显示弹出层
  const [protocolIdsVisible, setProtocolIdsVisible] = useState(false)

  // 是否显示弹出层
  const [monthVisible, setMonthVisible] = useState(false)
  // 当前选中月份
  // eslint-disable-next-line no-magic-numbers
  const [currentMonth, setCurrentMonth] = useState<number>(12)

  // 月份数组
  const monthArr = [
    // {
    //   key: 1,
    //   num: 3,
    // },
    {
      key: 2,
      num: 6,
    },
    {
      key: 3,
      num: 9,
    },
    {
      key: 4,
      num: 12,
    },
  ]

  // 选择月份
  const selectMonth = (num: number) => {
    setCurrentMonth(num)
    setMonthVisible(false)
  }

  // 倒计时
  const [countdownTime, setCountdownTime] = useState<number>(5)
  const timer = useRef<ReturnType<typeof setTimeout>>()

  // 倒计时
  useEffect(() => {
    if (isMobile) {
      if (countdownTime > 0) {
        timer.current = setTimeout(() => {
          setCountdownTime(countdownTime - 1)
        }, 1000)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdownTime])

  const buildAgreementUrl = (agreementId: string | number, title?: string) => {
    const serialNoQuery = protocolSerialNo ? `&serialNo=${encodeURIComponent(protocolSerialNo)}` : ''
    const titleQuery = title ? `&title=${encodeURIComponent(title)}` : ''
    return `/info-audit-agreement?isShowHeader=true&agreementId=${agreementId}${titleQuery}&productId=${rqResult.id}${serialNoQuery}`
  }

  const checkOtherProtocols = (item: any) => {
    if (item.id) {
      openOtherView(buildAgreementUrl(item.id, item.name))
    } else if (item.url) {
      window.location.href = item.url
    }
  }

  return (
    <section className={styles.authorizePage}>
      {/* <Header title="卫付通" /> */}
      <div>
        {
          rqResult?.thirdpartyType && rqResult?.thirdpartyType !== 5 ? <>
            {
              apiChannelCode || isHalfProcess ? <>
                <ApiToH5Skin
                  rqResult={rqResult ? rqResult : {}}
                  agreementContent={agreementContent}
                  youqianlaiProtocolName={youqianlaiProtocol?.name}
                  isSpecialChannel={isSpecialChannel}
                  isHalfProcess={isHalfProcess}
                  hasOtherProtocols={(otherProtocols || []).length > 0}
                />
              </> : <>
                {
                  rqResult?.thirdpartyType && <div>
                    <div className={styles.headerBox}>
                      {/* <img className={styles.textTips} src={require('@imgs/information/text-tips.png')} /> */}
                      严选正规机构100+，卫付通为您匹配最低息借款方案
                    </div>
                    <div className={styles.mainContent}>
                      <div className={styles.limitBox}>
                        <div className={styles.limitBoxTitle}>最高可借额度（元）</div>
                        <div className={styles.limitNum}>{ details?.applyLimit >= 3 ? '100,000' : '50,000'}</div>
                        <div className={styles.splitLine}></div>
                        <div className={styles.limitBoxFooter}>
                          <div className={styles.footerItem}>
                            <img className={styles.footerItemIcon} src={require('@imgs/information/ic_safe-1.png')} />
                            <span>年化利率7.2%-24%</span>
                          </div>
                          <div className={styles.footerItem}>
                            <img className={styles.footerItemIcon} src={require('@imgs/information/ic_safe-2.png')} />
                            <span>随时可还款</span>
                          </div>
                          <div className={styles.footerItem}>
                            <img className={styles.footerItemIcon} src={require('@imgs/information/ic_safe-3.png')} />
                            <span>额度灵活</span>
                          </div>
                        </div>
                      </div>
                      {
                        rqResult.thirdpartyType === 7 && wholeProcessBumpVO ? <>
                          <div className={styles.yqlWholeProcessBox}>
                            <div className={styles.yqlWholeProcessBoxHeader}>
                              <img className={styles.yqlWholeProcessBoxHeaderIcon} src={require('@imgs/information/checked2.png')} />
                              <div className={styles.yqlWholeProcessBoxHeaderTitle}>恭喜您，贷款匹配成功</div>
                            </div>
                            <div className={styles.splitLine}></div>
                            <div className={styles.yqlWholeProcessBoxContent}>
                              <div className={styles.yqlWholeProcessBoxContentItem}>
                                <div className={styles.contentItemName}>贷款服务机构</div>
                                <div className={styles.contentItemRight}>
                                  <div className={styles.contentItemText}>
                                    <span>{ wholeProcessBumpVO.partnerProductName }</span>
                                    {
                                      wholeProcessBumpVO.partnerCompanyName && <span>{ `(${wholeProcessBumpVO.partnerCompanyName})` }</span>
                                    }
                                  </div>
                                  {
                                    wholeProcessBumpVO.partnerLogo ? <>
                                      <img className={styles.contentItemIcon} src={wholeProcessBumpVO.partnerLogo} />
                                    </> : <>
                                      <img className={styles.contentItemIcon} src={require('@imgs/information/loan-institutions.png')} />
                                    </>
                                  }
                                </div>
                              </div>
                              {
                                (wholeProcessBumpVO.orgProductName || wholeProcessBumpVO.orgCompanyName) && <div className={styles.yqlWholeProcessBoxContentItem}>
                                  <div className={styles.contentItemName}>服务机构</div>
                                  <div className={styles.contentItemRight}>
                                    <div className={styles.contentItemText}>
                                      {
                                        wholeProcessBumpVO.orgProductName && <span>{ wholeProcessBumpVO.orgProductName }</span>
                                      }
                                      {
                                        wholeProcessBumpVO.orgCompanyName && <span>{ `(${wholeProcessBumpVO.orgCompanyName})` }</span>
                                      }
                                    </div>
                                    <img className={styles.contentItemIcon} src={require('@imgs/information/loan-institutions.png')} />
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </> : <>
                          <div className={styles.loanDurationBox} onClick={() => setMonthVisible(true)}>
                            <div>借多久</div>
                            <div className={styles.loanDurationBoxRight}>
                              { currentMonth }个月
                              <img className={styles.arrowBlack} src={require('@imgs/information/arrow-black.png')} />
                            </div>
                          </div>
                          <div className={styles.productBox}>
                            <div className={styles.productTitle}>
                              <div className={styles.titleLine}></div>
                              为您匹配
                            </div>
                            <div className={styles.splitLine}></div>
                            <div className={styles.productNameBar}>
                              <img className={styles.productIcon} src={require('@imgs/information/product.png')} />
                              <span>{ rqResult && rqResult.externalName }</span>
                            </div>
                            {/* <div className={styles.companyBox}>
                              <img className={styles.companyIcon} src={require('@imgs/information/company.png')} />
                              <span>{ rqResult && rqResult.productCompany }</span>
                            </div> */}
                          </div>
                        </>
                      }
                      <div className={styles.protocolBox}>
                        <div className={styles.specialTips}>
                          特别提示：我们会根据您的资质，为您匹配专业的贷款咨询服务机构，请您查阅《个人信息共享授权协议》
                        </div>
                        <div className={styles.protocolBoxContent}>
                          <div className={styles.protocolBoxTitle}>{ youqianlaiProtocol?.name }</div>
                          <div dangerouslySetInnerHTML={{ __html: agreementContent }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </>
            }
            <div className={styles.footerBox}>
              <div className={styles.footerText}>
                {
                  checked ? <>
                    <img onClick={checkedTaggle} className={styles.checkedIcon} src={require('@imgs/information/checked.png')} />
                  </> : <>
                    <div className={classNames(styles.checked)} onClick={checkedTaggle}></div>
                  </>
                }
                <div>
                  <span onClick={checkedTaggle}>同意并签署</span>
                  {
                    youqianlaiProtocol?.id && <span
                      className={styles.footerTextRed}
                      onClick={() => {
                        openOtherView(buildAgreementUrl(youqianlaiProtocol.id, youqianlaiProtocol.name))
                      }}
                    >
                《{youqianlaiProtocol.name}》
                    </span>
                  }
                  {
                    (otherProtocols || []).length > 0 && <span
                      className={styles.footerTextRed}
                      onClick={() => {
                        openProtocolsPopup()
                      }}
                    >
                    《机构相关协议》
                    </span>
                  }
                </div>
              </div>
              <div className={styles.btnBox}>
                <Button block loading={btnLoading} loadingText={isHalfProcess ? '提交中...' : '请等待机构申请结果'} className={styles.btn} shape="rounded" color="primary" onClick={() => submitApplication(true)}>
                  { isHalfProcess ? '确认申请' : `立即领取额度${countdownTime ? `（${countdownTime}s）` : ''}`}
                </Button>
              </div>
              <div className={styles.paddingBox}></div>
            </div>
          </> : <>
            <div id="root">
              <div id="loading-box">
                <div className={styles.ballClipRotateMultiple}>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </>
        }
      </div>
      <Popup
        visible={monthVisible}
        onMaskClick={() => {
          setMonthVisible(false)
        }}
      >
        <ul className={styles.monthBox}>
          {
            monthArr.map(item => {
              return <li
                key={item.key}
                className={classNames(styles.row, item.num === currentMonth && styles.active)}
                onClick={() => selectMonth(item.num)}
              >
                {item.num} 个月
              </li>
            })
          }
        </ul>
      </Popup>

      <Popup
        visible={protocolIdsVisible}
        showCloseButton={true}
        bodyStyle={{
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          minHeight: '40vh',
        }}
        onMaskClick={() => {
          setProtocolIdsVisible(false)
        }}
        onClose={() => {
          setProtocolIdsVisible(false)
        }}
      >
        <div className={styles.protcolPopup}>
          <div className={styles.popupTitle}>协议列表</div>
          <div className={styles.protocolIdsBox}>
            {
              otherProtocols.map((item:any, index:number) => {
                return (
                  <div
                    className={styles.protocolIdItem}
                    onClick={() => checkOtherProtocols(item)}
                    key={item.id || item.name || item.url || index}
                  >
                    <div>{ `《${item.name || '相关协议'}》` }</div>
                    <img className={styles.arrowBlack} src={require('@imgs/information/arrow-black.png')} />
                  </div>
                )
              })
            }
          </div>
        </div>
      </Popup>

      {/* 挽留弹窗 */}
      <ProtocolIdsConfirm1
        ref={ProtocolIdsConfirm1ModalRef}
        onSuccess={(e:any) => handleLoginSuccess(e)}
        openProtocolsPopup={() => openProtocolsPopup()}
        submit={() => handelSubmitData()}/>

      {/* 同意协议弹窗 */}
      <ProtocolIdsConfirm2
        ref={ProtocolIdsConfirm2ModalRef}
        onSuccess={(e:any) => handleLoginSuccess(e)}
        openProtocolsPopup={() => openProtocolsPopup()}
        submit={() => handelSubmitData()}/>

    </section>
  )
}

export default Authorize